export default __webpack_public_path__ + "static/media/arrow_down.bb25fc77.svg";